import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import UserService from '../../../../services/user/UserService';
import ModalCetakSpt from './ModalCetakSpt';

const ModalViewSpt = ({ showViewSpt, handleCloseViewSpt, rowData }) => {
    // console.log(rowData)

    const [valueUptOpt, setValueUptOpt] = useState(null)
    // const [valueKdUpt, setValueKdUpt] = useState(null)
    const [showCetakSpt, setShowCetakSpt] = useState(false)
    const handleCloseCetakSpt = () => setShowCetakSpt(false)

    let userService = useMemo(() => new UserService(), [])

    useEffect(() => {
        if(!rowData) return 

        const fetchOptions = async () => {
            const resUpt = await userService.getUptById(rowData.kdUpt)
            setValueUptOpt(resUpt.data)
        }
        fetchOptions()
    }, [userService, rowData])

    async function loadOptionUpt(search, loadedOption, { page = 1 }) {
        const response = await userService.listUpt(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const handleClickCetakSpt = () => {
        setShowCetakSpt(true)
    }

    return (
        <>
            <Modal show={showViewSpt} onHide={handleCloseViewSpt} backdrop='static' keyboard={false} scrollable={true} size='xl' centered>
                <Modal.Header>View Surat Perintah Tugas</Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">NIB</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.nib} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Proyek</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_proyek" defaultValue={rowData !== null && rowData.nomorProyek} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor SPT</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-8 form-control-sm" name="nomor_spt" defaultValue={rowData !== null && rowData.nomorSpt} disabled />{' '}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tanggal SPT</label>
                        <div className="col-sm-4">
                            <input type="date" className="col-sm-12 form-control-sm" name="tanggal_spt" defaultValue={rowData !== null && rowData.tanggalSpt} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">UPT</label>
                        <div className="col-sm-10">
                            {/* <input type="text" className="col-sm-12 form-control-sm" name="upt" placeholder="UPT" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionUpt}
                                value={valueUptOpt}
                                getOptionValue={(option) => option.kdUnit}
                                getOptionLabel={(option) => option.nmUnit}
                                additional={{
                                    page: 1,
                                }}
                                isDisabled={true}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-10">
                            <input type="text" className="col-sm-12 form-control-sm" name="pejabat_ttd" defaultValue={rowData !== null && rowData.pejabatTtd} disabled/>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Jabatan Penandatangan</label>
                        <div className="col-sm-10">
                            <input type="text" className="col-sm-12 form-control-sm" name="jabatan_ttd" defaultValue={rowData !== null && rowData.jabatanTtd} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleClickCetakSpt()} >Cetak</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseViewSpt}>
                        Tutup
                    </Button>
                </Modal.Footer>
            </Modal>
            <ModalCetakSpt showCetakSpt={showCetakSpt} handleCloseCetakSpt={handleCloseCetakSpt} rowData={rowData}/>
        </>
    )
}

export default ModalViewSpt